import React from 'react'
import Layout from '../components/common/layout'
import CareersComp from '../components/careers'
import SEO from '../components/common/seo'

const CareersPage = () => (
  <Layout>
    <SEO title="San Diego Refrigeration &amp; A/C Repair" />
    <CareersComp />
  </Layout>
)

export default CareersPage
